module.exports = __webpack_public_path__ + "static/img/1-1.4206b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/1-1.png
// module id = esj7
// module chunks = 1